'use strict';

var redux = require('redux');

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};



































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var multiPartyLoadingStateReducerFactory = function multiPartyLoadingStateReducerFactory() {
    for (var _len = arguments.length, triggerLoadActionTypes = Array(_len), _key = 0; _key < _len; _key++) {
        triggerLoadActionTypes[_key] = arguments[_key];
    }

    return function () {
        for (var _len2 = arguments.length, haltLoadActionTypes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            haltLoadActionTypes[_key2] = arguments[_key2];
        }

        /* State shape
             loadingState: {
                 partiesLoading: [],
                 partiesHaveLoaded: [],
                 successByParty: {},
                 errorsByParty: {}
             }
         */

        var partiesLoadingReducer = function partiesLoadingReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var action = arguments[1];
            var payload = action.payload;


            if (triggerLoadActionTypes.includes(action.type) && payload.partyKey) {
                return [].concat(toConsumableArray(state), [payload.partyKey]);
            } else if (haltLoadActionTypes.includes(action.type) && payload.partyKey) {
                return [].concat(toConsumableArray(state)).filter(function (key) {
                    return key !== payload.partyKey;
                });
            }

            return state;
        };

        var partiesHaveLoaded = function partiesHaveLoaded() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var action = arguments[1];
            var payload = action.payload;


            if (haltLoadActionTypes.includes(action.type) && payload.partyKey) {
                return [].concat(toConsumableArray(state), [payload.partyKey]);
            } else if (triggerLoadActionTypes.includes(action.type) && payload.partyKey) {
                return [].concat(toConsumableArray(state)).filter(function (key) {
                    return key !== payload.partyKey;
                });
            }

            return state;
        };

        var successReducer = function successReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var action = arguments[1];
            var payload = action.payload;


            if (haltLoadActionTypes.includes(action.type) && payload.partyKey) {
                return Object.assign({}, state, defineProperty({}, payload.partyKey, action.payload.success));
            }

            return state;
        };

        var errorsReducer = function errorsReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var action = arguments[1];
            var payload = action.payload;


            if (haltLoadActionTypes.includes(action.type) && payload.partyKey) {
                return Object.assign({}, state, defineProperty({}, payload.partyKey, action.payload.errors));
            }

            return state;
        };

        return redux.combineReducers({
            partiesLoading: partiesLoadingReducer,
            partiesHaveLoaded: partiesHaveLoaded,
            successByParty: successReducer,
            errorsByParty: errorsReducer
        });
    };
};

module.exports = multiPartyLoadingStateReducerFactory;
